export const DEPARTMENTS_IDS = {
  FAMILY_MEDICINE: "5e4a3ebf-b763-43a0-a747-57a6c2aa88c0", //
  GENERAL_THERAPY: "4064b632-94fe-425e-9155-cb19a8d13bea", // +
  NEUROLOGICAL: "fd5bd7c3-4632-4be4-adeb-98e7b3f65229", // +
  GENERAL_SURGICAL: "328ef9a9-e84e-4131-acf5-343c6239aa5f", // +
  EMERGENCY: "9de72c10-d07b-439c-afd1-c5602944527d", // +
  REHABILITATION: "4c44f7d3-880f-4cc0-8eec-8bbabdb11c70", // +
  PALIATIVE: "1f260b7b-2aa5-4680-b6a1-030e363dc6e5", // +
  POLYCLINIC: "10898708-f1ed-4b68-9e13-a6a55e89d600", // +
  RADIOLOGY: "efb0a697-7c9c-4516-ad70-0ee47713b108", // +

}
